import { useEffect, useState } from 'react'
import { api, ApiError } from './api'
import { ProjectView } from './project/ProjectView'
import { Logo, Spinner } from './ui'

export function ShareGate({ token }: { token: string }) {
  const [info, setInfo] = useState<{ projectId: string; title: string; client: string; signedIn: boolean; name: string } | null>(null)
  const [error, setError] = useState('')
  const [name, setName] = useState(() => {
    try {
      return localStorage.getItem('osel-name') || ''
    } catch {
      return ''
    }
  })
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [entered, setEntered] = useState(false)

  useEffect(() => {
    api
      .get<typeof info>(`s/${token}`)
      .then((i) => {
        setInfo(i)
        if (i?.signedIn) setEntered(true)
      })
      .catch((e) => setError(e instanceof ApiError ? e.message : 'This link is not working.'))
  }, [token])

  if (error && !info) {
    return (
      <div className="fullpage">
        <div className="signin">
          <Logo size={40} />
          <h1>Link not active</h1>
          <p>{error}</p>
        </div>
      </div>
    )
  }
  if (!info) return <div className="fullpage"><Spinner /></div>
  if (entered) return <ProjectView projectId={info.projectId} anthropic={false} />

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setError('')
    try {
      await api.post(`s/${token}/login`, { password, name })
      try {
        localStorage.setItem('osel-name', name)
      } catch {
        /* private mode */
      }
      setEntered(true)
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not open the project.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="fullpage">
      <form className="signin" onSubmit={submit}>
        <Logo size={40} />
        <p className="eyebrow">{info.client || 'Osmo'}</p>
        <h1>{info.title}</h1>
        <p>Watch the interviews, read along, and highlight the lines you want in the film.</p>
        <label className="field">
          <span>Your name</span>
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="So your team knows who picked what" autoComplete="name" required maxLength={60} />
        </label>
        <label className="field">
          <span>Password</span>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
        </label>
        <button className="btn btn-primary btn-lg" disabled={busy}>{busy ? 'Opening…' : 'Open project'}</button>
        {error && <p className="error">{error}</p>}
      </form>
    </div>
  )
}
